import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import CheckBox from 'components/final-form/CheckBox';
import DatePicker from 'components/final-form/DatePicker';
import PraxFormGrid from 'components/layout/PraxFormGrid';

interface Props extends MessageSourceProps {
  visible: boolean,
  disabledBefore?: Date,
  readOnly: boolean
}

interface State {
  visible: boolean
}

class HospitalizationSegment extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {visible} = this.props;

    this.state = {
      visible: visible
    }
  }

  toggleVisibility = () => {
    this.setState(({visible}: State) => ({
      visible: !visible
    }))
  };

  render(): React.ReactNode {

    const {disabledBefore, getMessage, readOnly} = this.props;
    const {visible} = this.state;

    const display = visible ? "flex" : "none";

    return (
        <PraxFormGrid verticalAlign="middle">
          <Grid.Row>
            <Grid.Column verticalAlign="middle">
              <h4>{getMessage('hospitalization')}</h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column verticalAlign="middle">
              <Field
                  name="isHospitalized"
                  component={CheckBox}
                  label={getMessage('hospitalization')}
                  onClick={this.toggleVisibility}
                  disabled={readOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{display: display}}>
            <Grid.Column width={2} verticalAlign="middle">
              {getMessage('from')}
            </Grid.Column>
            <Grid.Column width={4} verticalAlign="middle">
              <Field
                  name="hospitalizationFrom"
                  component={DatePicker}
                  disabled={readOnly}
              />
            </Grid.Column>
            <Grid.Column width={2}/>
            <Grid.Column width={2} verticalAlign="middle">
              {getMessage('to')}
            </Grid.Column>
            <Grid.Column width={4} verticalAlign="middle">
              <Field
                  name="hospitalizationTo"
                  component={DatePicker}
                  disabledBefore={disabledBefore}
                  disabled={readOnly}
              />
            </Grid.Column>
          </Grid.Row>
        </PraxFormGrid>
    );
  }
}

export default withMessages(HospitalizationSegment);
